import React from 'react';
import moment from 'moment';
import { onlineApplicationStyles } from './styles';

interface ExpirationMessageProps {
  expirationDate: string | undefined;
  buttonText?: string;
}

export const ExpirationMessage: React.FC<ExpirationMessageProps> = ({ expirationDate, buttonText }) => {
  return (
    <div style={onlineApplicationStyles.message.warning.container}>
      <div style={onlineApplicationStyles.message.confirm.text}>
        この度はAI Travelをご検討いただき、誠にありがとうございます。
        <br />
        内容をご確認のうえ、問題がなければ「{buttonText}」ボタンを押してください。
        <br />
        なお、担当者情報に修正が必要な場合は、あわせてご編集をお願いいたします。
      </div>
      {expirationDate && (
        <div style={onlineApplicationStyles.message.error.text}>
          申込有効期限：{moment(expirationDate).format('YYYY/MM/DD')}
        </div>
      )}
    </div>
  );
};
